/**
 * General utils
 */

/**
 * Get a random identifier string
 * @returns {string}
 */
const identifier = function() {
    return '_' + Math.random().toString(36).substr(2, 9);
};

export default {
    /**
     * Give a unique ID to a DOM element and return it
     * @param {jQuery} $element
     * @return string
     */
    uniqueID:     function($element) {
        if ($element[0].hasAttribute('id')) {
            return $element.attr('id');
        }

        let id;
        do {
            id = identifier();
        } while ($(`#${id}`).length > 0);

        $element.attr('id', id);

        return id;
    },
    /**
     * Ensure where applicable the attributes of an element
     * are converted to vue binding attributes
     *
     * @param {jQuery} $elements
     * @param {string[]} attributes
     */
    vueBind:      function($elements, attributes) {
        let bindingRegex = /{{.+}}/;
        $elements.each(function() {
            let $elem = $(this);
            attributes.forEach(function(attr) {
                if (!$elem[0].hasAttribute(attr)) {
                    return;
                }
                if (bindingRegex.test($elem.attr(attr))) {
                    $elem.attr(`v-bind:${attr}`, $elem.attr(attr));
                    $elem.removeAttr(attr);
                }
            });
        });
    },
    /**
     * Append a nested object to formdata
     * @param {FormData} formData
     * @param {Object} obj
     * @param {string} [name]
     */
    appendObject: function(formData, obj, name) {
        let keyName;
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (name === undefined) {
                    keyName = key;
                } else {
                    keyName = [name, '[', key, ']'].join('');
                }
                if (obj[key] instanceof Object) {
                    this.appendObject(formData, obj[key], keyName);
                } else {
                    formData.append(keyName, obj[key]);
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/utils.js